import React, { Component } from 'react';
import { FILE_URL,path } from './Constant';
let $=window.$;
export default class Concierge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            static_text:props.static_text
        }
        //console.log(props)
    }

    componentDidMount =()=>{
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $("#welcome-area").offset().top-50
            }, 500);
        }, 500);
    }

    render() {
        return (
            <div id="welcome-area">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12" id="concierge-div">
                                {/* <h4>{'Concierge'}</h4> */}
                                <div className="row py-4">
                                   
                                {  
                                     this.props.data.map((data,key)=>{
                                        return(
                                            <div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 col-6">
                                                <div className="image-block" >
                                                <img src={FILE_URL+'villas/'+data.image} className="img-fluid d-block" alt={'Why Us'} />
                                           
                                                </div>
                                            <p className="pt-1 text-center">{data.legend}</p>
                                           </div>
                                        )
                                       
                                    })
                                }
                                </div>
                       
                           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
